import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

// ui
import DashboardContainer from '../../containers/Dashboard';
import AuthUserContainer from '../../containers/AuthUser';
import FMPSectionCard from '../../components/ui/FMPSectionCard';

// icons
import Stocks from '../../images/icons/stocks.svg';
import Forecast from '../../images/icons/fuelForecast.svg';
import IncomingData from '../../images/icons/incomingDocuments.svg';
import GasPump from '../../images/icons/gasPump.svg';

const styles = (theme) => {
	return {
		root: {
			width: '100%',
			height: 'auto',
			zIndex: 1,
			overflow: 'hidden',
			backgroundColor: '#e5e5e6',
		},
		panel: {
			marginTop: 30,
		},
		emptyPanel: {
			minHeight: 270,
			fontWeight: 100,
			color: '#aaa',
			fontSize: 30,
			marginTop: 30,
		},
		innerPaper: {
			padding: 10,
			paddingTop: 5,
			textAlign: 'left',
			fontSize: 14,
			[theme.breakpoints.up('md')]: {
				padding: 40,
				paddingTop: 30,
			},
		},
		lastFtpCheck: {
			//marginTop : 20,
			//color : "#888"
		},
		ftpSection: {
			lineHeight: 1.6,
			marginTop: 10,
		},
		title: {
			textTransform: 'uppercase',
			color: '#777',
			fontWeight: 900,
			letterSpacing: 2,
			marginBottom: 5,
		},
		label: {},

		labelDate: {
			fontSize: 12,
			fontWeight: 100,
			color: '#999',
		},
		value: {
			fontWeight: 600,
		},
		statusIcon: {
			position: 'absolute',
			right: 0,
		},
		ftpWarning: {
			color: '#FFC107',
		},
		ftpGood: {
			color: '#4CAF50',
		},
		ftpStatusIcon: {
			width: 14,
			height: 14,
			verticalAlign: 'middle',
			paddingLeft: 5,
		},
		ftpStatusIconLarge: {
			width: 32,
			height: 32,
			verticalAlign: 'middle',
		},
		dataSection: {
			marginTop: 25,
			lineHeight: 1.6,
		},
		dgsButton: {
			position: 'relative',
			right: 0,
			borderRadius: 100,
		},
		dgsButtonContainer: {
			display: 'flex',
			justifyContent: 'flex-end',
			marginTop: 30,
		},
		tableRow: {
			fontWeight: 400,
		},
		row: {
			margin: 0,
			width: '100%',
			backgroundColor: '#fff',
		},
		oddRow: {
			margin: 0,
			width: '100%',
			backgroundColor: '#eee',
		},
		masthead: {
			textAlign: 'left',
			fontSize: 24,
			color: '#666',
			letterSpacing: 0,
			textTransform: 'uppercase',
			fontWeight: 300,
			marginBottom: 15,
			marginTop: 15,
			//margin: '2px 0px 5px 0px',
			position: 'relative',
			marginLeft: 0,

			[theme.breakpoints.up('sm')]: {
				fontWeight: 300,
				fontSize: 22,
				//margin: '10px 0px 10px 0px',
			},
			[theme.breakpoints.up('md')]: {
				fontSize: 30,
				//margin: '10px 0px 10px 0px',
			},
		},
		subMasthead: {
			textAlign: 'left',
			fontSize: 18,
			color: '#666',
			letterSpacing: 0,
			textTransform: 'uppercase',
			fontWeight: 300,
			marginBottom: 10,
			marginTop: 15,
			//margin: '2px 0px 5px 0px',
			position: 'relative',
			marginLeft: 0,
		},
	};
};

class ReportingDashboard extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	render() {
		const { classes } = this.props;

		return (
			<>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<div className={classes.masthead}>Reporting Dashboard</div>
					</Grid>

					<Grid item xs={12} sm={6}>
						<FMPSectionCard
							title={'Total Monthly Sales Volume'}
							icon={Stocks}
							description={`See a breakdown of E85 volume totals with the 
							current month compared against the prior month's volume numbers. 
							Broken down by day in a graph to compare day by day volume amount.
							`}
							url={'/reports/totalVolume'}
						/>
					</Grid>

					<Grid item xs={12} sm={6}>
						<FMPSectionCard
							title={'Station Sales Volume'}
							icon={GasPump}
							description={`Day by Day breakdown of daily sales for each of our stations that 
							are hooked up to reporting. Include monthly station by station breakdown which allows 
							comparison of current month sales numbers vs last month on a per station basis.
							Station by station breakdown includes anomaly detection stations grossly lower or higher
							to catch issues with our stations.
						 `}
							url={'/reports/stationVolume'}
						/>
					</Grid>

					<Grid item xs={12} sm={6}>
						<FMPSectionCard
							title={'Fuel Forecast'}
							icon={Forecast}
							description={`
							Iterates through each station and compares the volume for each day of the current month to that of the average of 
							that same day of the week to last month. After the percentage change for each station for every day is calculated 
							then the system calculates the mean for that day and produces the average percentages change over last month for 
							that day and that is what is shown in the graph.
							`}
							url={'/reports/fuelForecast'}
						/>
					</Grid>

					<Grid item xs={12} sm={6}>
						<FMPSectionCard
							title={'OPIS Data Reporting'}
							icon={IncomingData}
							description={`Day by day listing or all the data we import from OPIS on a daily basis and 
				our projected monthly average of these values. These number are the basis for many of our pricing formulas 
				in our system and these page allows drill down into the individual numbers.`}
							url={'/reports/opisPricing'}
						/>
					</Grid>
				</Grid>
			</>
		);
	}
}

ReportingDashboard.propTypes = {
	classes: PropTypes.object.isRequired,
	searchOpisFtpRecords: PropTypes.func.isRequired,
	opisFtpRecords: PropTypes.array,

	searchDataRecords: PropTypes.func.isRequired,
	dataRecords: PropTypes.array,
	addDataRecord: PropTypes.func.isRequired,

	userMap: PropTypes.object,
	authUser: PropTypes.object,

	isExternalLogistics: PropTypes.bool,
};

export default _.flow([withStyles(styles), AuthUserContainer, DashboardContainer])(
	ReportingDashboard
);
